module.exports = __webpack_public_path__ + "static/media/map.1fcd54e2.png";